import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, MenuItem } from '@mui/material';
import { DatePicker, Select } from 'mui-rff';
//
import ButtonSubmit from 'components/common/ButtonSubmit';
import { DEFAULT_DATE_FORMAT } from '../../../constants/reports';
import { PICKER_MIN_DATE } from '../../../constants';
import { filterParamsForm } from 'utils/normalizers';

const FilterPanel = ({
  applyFilters,
  initialValues,
  clientOptionsData,
  publisherOptionsData,
  endpointOptionsData,
}) => {
  const onSubmit = useCallback(
    (values) => applyFilters(filterParamsForm(values)),
    [applyFilters],
  );
  return (
    <Form
      initialValues={initialValues}
      onSubmit={(values) => onSubmit(values)}
      render={({ handleSubmit, submitting, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid
            container
            alignItems='flex-start'
            spacing={2}
            px='16px'
            mt='15px'
            mb='10px'
          >
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <DatePicker
                name='startDate'
                margin='none'
                label='Start Date'
                minDate={PICKER_MIN_DATE}
                disableFuture
                maxDate={values['endDate']}
                dateFunsUtils={DateFnsUtils}
                format={DEFAULT_DATE_FORMAT}
                inputFormat={DEFAULT_DATE_FORMAT}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <DatePicker
                name='endDate'
                margin='none'
                label='End Date'
                disableFuture
                minDate={values['startDate']}
                dateFunsUtils={DateFnsUtils}
                format={DEFAULT_DATE_FORMAT}
                inputFormat={DEFAULT_DATE_FORMAT}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Select name='wlids' label='Client' multiple>
                {clientOptionsData.map((item, index) => (
                  <MenuItem value={item.wlid} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Select name='publishers' label='Publisher' multiple>
                {publisherOptionsData.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Select name='endpoints' label='Endpoint' multiple>
                {endpointOptionsData.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Select name='statuses' label='Status' multiple>
                <MenuItem value='NEW'>New</MenuItem>
                <MenuItem value='PENDING'>Pending</MenuItem>
                <MenuItem value='SUCCEEDED'>Succeeded</MenuItem>
                <MenuItem value='CANCELED'>Canceled</MenuItem>
              </Select>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <ButtonSubmit
                type='submit'
                name='Apply'
                onSubmit={handleSubmit}
                isPending={submitting}
                style={{ textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default FilterPanel;
